import type { HTMLAttributes } from 'react';
import styled from 'styled-components';
import { Spacing16, Spacing24, Spacing32 } from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';
import { customScrollbar } from 'modules/helpers/mixins';
import { breakpoint, sizes } from 'variables';
import Header from './components/Headline';
import Search from './components/Search';
import type { IQuickViewSearch } from './shared/types';

// #region Styles
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacing32};
    min-height: 0;
    flex: 0 1 100%;
`;

const Container = styled.div`
    width: 100%;
    padding: 0 ${Spacing24} ${Spacing24};
    overflow: auto;
    ${customScrollbar};

    ${breakpoint.up(sizes.md)} {
        width: 480px;
    }
`;

const SubHeadline = styled(Typography.Body)`
    margin-bottom: ${Spacing16};
`;
// #endregion Styles

export default function QuickViewSearch(props: IQuickViewSearch & HTMLAttributes<HTMLDivElement>) {
    const {
        translations: { headline, subHeadline, search },
        inputType,
        searchQuery,
        trackingCategory,
        children,
        inputRef,
        productInfo,
        ...restProps
    } = props;

    return (
        <Wrapper>
            <Container {...restProps}>
                <Header headline={headline} />
                {subHeadline && <SubHeadline>{subHeadline}</SubHeadline>}
                <Search
                    translations={search}
                    inputType={inputType}
                    searchQuery={searchQuery}
                    inputRef={inputRef}
                    trackingCategory={trackingCategory}
                />
                {children}
            </Container>
        </Wrapper>
    );
}
